import * as types from './mutation-types'
import checkinApi from '../../endpoints/checkin'
import shopsApi from '../../endpoints/shop'
import store from '@/store'

export const actions = {

    async checkin({ commit, dispatch, getters, rootGetters }, payload) {

        commit(types.CHECKIN_LOADING)

        const { data } = await checkinApi.checkin(payload)

        if (data.data.hcode === "ko") {
            commit(types.CHECKIN_ERROR, { error: error, data: null })
            return
        }

        commit(types.CHECKIN_COMPLETE, data.data.data.shopInfo)
        
        //clean cart when shop changed
        if(getters.current.oid !== payload) {
            store.dispatch('cart/cartClean')
        }

        return data
    }

}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/checkin/actions.js
// module id = null
// module chunks = 